import { useTranslate, useNotify, useRefresh, useUpdate } from "react-admin";
import { Dialog, Typography } from "@mui/material";
import { handleHttpError } from "shared/src/utils/errorHandler";
import { NumberInput, ReferenceInput, required, SimpleForm } from "react-admin";
import { RaAutocompleteInput } from "../../components/inputs/Ra/RaAutocompleteInput";
import { RaSelectInput } from "shared/src/components/inputs/Ra/RaSelectInput";
import { SimpleToolbar } from "../../components/SimpleToolbar";

export const EditSkuModal = ({ open, onClose, skuRecord, setEditSkuModalOpen }) => {
    const translate = useTranslate();
    const notify = useNotify();
    const refresh = useRefresh();
    const [update] = useUpdate();

    const handleCreateSku = (sku) => {
        update(
            "skus",
            {
                id: sku.id,
                data: {
                    ...sku,
                    product: sku.product,
                    manufacturer: sku.manufacturer,
                    storageLocation: sku.storageLocation,
                    weight: sku.weight,
                    serialNumber: sku.serialNumber,
                },
            },
            {
                onSuccess: () => {
                    setEditSkuModalOpen(false);
                    refresh();
                },
                onError: (e) => {
                    handleHttpError(e, notify);
                },
            }
        );
    };

    return (
        <Dialog open={open} fullWidth>
            <Typography variant="h6" sx={{ padding: 2 }}>
                {translate("equip.editSku")}
            </Typography>
            <SimpleForm
                onSubmit={handleCreateSku}
                resource="skus"
                record={skuRecord}
                toolbar={<SimpleToolbar onClose={onClose} />}
            >
                <ReferenceInput
                    source="manufacturer.id"
                    reference="manufacturers"
                    sort={{ field: "name", order: "ASC" }}
                >
                    <RaAutocompleteInput
                        field="name"
                        label="equip.manufacturer"
                        validate={[required()]}
                    />
                </ReferenceInput>
                <ReferenceInput
                    source="storageLocation.id"
                    reference="storageLocations"
                    sort={{ field: "name", order: "ASC" }}
                >
                    <RaAutocompleteInput
                        label="equip.storageLocation"
                        field="name"
                        filterToQuery={(searchText) => ({
                            name: searchText,
                        })}
                    />
                </ReferenceInput>
                <NumberInput
                    title={translate("equip.weight")}
                    label="equip.weight"
                    source="weight"
                />
                <NumberInput
                    title={translate("equip.serialNumber")}
                    label="equip.serialNumber"
                    source="serialNumber"
                />
                <RaSelectInput
                    source="status"
                    required
                    choices={[
                        {
                            id: "active",
                            name: "equip.sku_status_active",
                        },
                        {
                            id: "deactivated",
                            name: "equip.sku_status_deactivated",
                        },
                    ]}
                />
                <RaSelectInput
                    source="availability"
                    required
                    choices={[
                        {
                            id: "available",
                            name: "equip.sku_availability_available",
                        },
                        {
                            id: "rented_out",
                            name: "equip.sku_availability_rented_out",
                        },
                        {
                            id: "in_repair",
                            name: "equip.sku_availability_in_repair",
                        },
                        {
                            id: "defect",
                            name: "equip.sku_availability_defect",
                        },
                        {
                            id: "lost",
                            name: "equip.sku_availability_lost",
                        },
                    ]}
                />
            </SimpleForm>
        </Dialog>
    );
};
